export const password_visibility_mixin = {
    data: () => ({ show_password: false, show_confirm_password: false }),
    methods: {
      toggle_password_visibility() {
        this.show_password = !this.show_password
      },
      toggle_confirm_password_visibility() {
        this.show_confirm_password = !this.show_confirm_password
      }
    }
  }